/**
 * SoW §4: "Updates are automatic... nobody has to reinstall anything." The service worker
 * activates a new version immediately (skipWaiting + clients.claim in sw.js) rather than
 * waiting for the user to close every tab. Combined with `_headers` marking index.html/sw.js
 * as no-store, the next navigation always picks up the new shell without any manual step.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || !import.meta.env.PROD) return;
  void navigator.serviceWorker.register('/sw.js');
}
